<template>
  <div id="app" :class="getLayoutMode">
    <router-view/>
    <ASpin class="spinning" :spinning="spinning" tip="加载中..."></ASpin>
    <Mqtt class="spinning"/>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Mqtt from '@/Mqtt'
export default({
  components: { Mqtt },
  data(){
    return {
    }
  },
  created(){
    this.init()
  },  
  computed: {
    ...mapState(['spinning']),
    ...mapGetters(['getLayoutMode'])
  },
  methods:{
    ...mapActions(['refreshTerminalAbnormal', 'refreshBasicConfig', 'refreshAllSettings']),
    init(){
      // this.$dialog.confirm({
      //   title: `浏览器内核信息：${navigator.userAgent}`
      // })
      this.$message.success("执行初始化加载")
      //刷新基础配置
      this.refreshBasicConfig()
      //加载初始数据
      this.loadData()
			//刷新所有设置
			this.refreshAllSettings()
    },
    loadData(){
      //设备异常信息
      this.refreshTerminalAbnormal()
    }
  }
})
</script>

<style lang="less">
#app{
  height: 100%;
  position: relative;
}
.spinning{
  z-index: -1;
  width: 100vw;
  // background-color: #ffffff40;
  height: 100vh;
  top: 0;
  left: 0;
  position: absolute !important;
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @spin-color: #00ffdc;
  @spin-shadow: 0 0 10px #ff0099a1;
  .ant-spin-dot{
    font-size: 28px;
    .ant-spin-dot-item{
      @dot-size: 12px;
      width: @dot-size;
      height: @dot-size;
      // background-color: @spin-color;
      // box-shadow: @spin-shadow;
    }
  }
  .ant-spin-text{
    padding-top: 6px;
    font-size: 18px;
    // color: @spin-color;
    // text-shadow: @spin-shadow;
  }
  &.ant-spin-spinning{
    z-index: 9999999;
  }
}
</style>
